<template>

    <div class="stories" v-if="stories">
        <swiper class="stories__thumbs " ref="thumbsRef" :options="storyThumbs">
            <template v-if="stories.length">
                <swiper-slide v-if="isShowAddHistoryBtn">
                    <div class="stories__thumbs-item stories__thumbs-item">
                        <div class="stories__thumbs-story d-flex" data-target="#modalHistory" data-toggle="modal">
                            &plus;
                        </div>
                    </div>
                </swiper-slide>

                <template v-for="(slide, idx) in stories">
                    <swiper-slide @click.native="slideClicked(idx)" v-if="slide.target" :key="idx">
                        <progress-circle
                            :image="slide.images.length ? ('/storage' + slide.images[0].path) : ( slide.target.avatar ? '/storage' + slide.target.avatar.path : '')"
                            :percent="slide.target.donationsProgress"
                            :is-show-progress="isShowProgress"
                            w="72" stroke-width="5"></progress-circle>
                    </swiper-slide>
                </template>
            </template>
        </swiper>

        <transition name="modal">
            <div class="stories__modal" v-show="showModal">
                <div class="stories__modal-wrapper d-flex">
                    <div class="stories__modal-header d-flex">
                        <img src="/assets/images/icons/logo-white.svg" alt="">
                        <a @click.prevent="closeModal"><span class="lnr lnr-cross"></span></a>
                    </div>
                    <div class="stories__modal-swiper d-flex">
                        <swiper @slideChange="slideChange" class="stories__gallery" ref="galleryRef" :options="storyGallery">
                            <template v-if="stories.length">
                                <template v-for="(slide, idx) in stories">
                                    <swiper-slide :class="{'stories--prev': idx < slideIndex - 1, 'stories--prev-last': idx === slideIndex - 2}" :key="idx" v-if="slide.target">
                                        <div class="stories__gallery-item d-flex swiper-lazy" v-if="slide.target"
                                             :data-background="slide.images.length ? '/storage' + useConvertFilter(slide.images[0].path, 'full') :
                                             slide.target.avatar ? '/storage' + useConvertFilter(slide.target.avatar.path, 'full') : ''"
                                        >
                                            <transition name="fade">
                                                <div class="stories__gallery-info" v-show="idx !== slideIndex">
                                                    <progress-circle
                                                        font-size="24"
                                                        font-size-percent="17"
                                                        :image="slide.images.length ? ('/storage' + useConvertFilter(slide.images[0].path, 'full')) : ( slide.target.avatar ? '/storage' + slide.target.avatar.path : '')"
                                                        :percent="slide.target.donationsProgress"
                                                        w="98"
                                                        stroke-width="5"
                                                    ></progress-circle>
                                                    <div class="stories__gallery-info-name" v-text="slide.target.name"></div>
                                                </div>
                                            </transition>
                                            <transition name="fade">
                                                <div class="stories__gallery-content" v-show="idx === slideIndex">
                                                    <div class="stories__gallery-header d-flex">
                                                        <a :href="slide.target.url" class="stories__thumbs-item p-0">
                                                            <progress-circle :image="slide.target.avatar ? ('/storage' + slide.target.avatar.path) : ''" :percent="slide.target.donationsProgress" w="30" stroke-width="2"></progress-circle>
                                                        </a>
                                                        <a :href="slide.target.url" class="stories__gallery-info-name" v-text="slide.target.name"></a>
                                                    </div>
                                                    <div v-if="slide.description && (idx >= slideIndex - 2 || idx <= slideIndex + 2)">
                                                        <div class="stories__gallery-body">
                                                            <span v-html="prepareDescription(slide.description).htmlString"></span>
                                                            <button @click.prevent="readMore = true" href="#" class="read-more-button">Read more</button>
                                                        </div>
                                                    </div>
                                                    <div class="stories__gallery-body-full-bg" @click="readMore = false" v-if="readMore"></div>
                                                    <div class="stories__gallery-body-full" :style="{height: readMore ? '80%' : 0}">
                                                        <div class="stories__gallery-body-full-title">
                                                            {{ slide.target.name }}
                                                            <div @click="readMore = false">
                                                                <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <rect width="15.3708" height="1.51813" rx="0.759067" transform="matrix(0.706717 -0.707497 0.706717 0.707497 0.0654297 11.9072)" fill="#929292"/>
                                                                    <rect width="1.51813" height="15.3708" rx="0.759067" transform="matrix(0.706717 -0.707497 0.706717 0.707497 0 2.04207)" fill="#929292"/>
                                                                </svg>
                                                            </div>
                                                        </div>
                                                        <div class="stories__gallery-body-full-content" v-html="slide.description"></div>
                                                        <div class="stories__gallery-body-full-footer d-flex align-items-center row m-0">
                                                            <div class="col-4 d-flex align-items-center justify-content-center">
                                                                <progress-circle
                                                                    :showPercentAlways="true"
                                                                    :percent="slide.target.donationsProgress"
                                                                    percent-color="#000000"
                                                                    w="42"
                                                                    stroke-width="3"
                                                                ></progress-circle>
                                                            </div>
                                                            <div class="col-8 pl-0">
                                                                <a :href="slide.target.url" class="btn py-1 btn--round w-100"><small>Поддержать</small></a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </transition>
                                        </div>
                                    </swiper-slide>
                                </template>

                                <div class="story-btn story-prev" @click="prevSlide" slot="button-prev"><span class="lnr lnr-chevron-left"></span></div>
                                <div class="story-btn story-next" @click="nextSlide" slot="button-next"><span class="lnr lnr-chevron-right"></span></div>

                            </template>
                        </swiper>

                    </div>
                </div>

            </div>
        </transition>
    </div>

</template>

<script>
import ProgressCircle from "./chunk/ProgressCircle.vue";
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'

export default {
    name: "StoryLine",
    components: {
        Swiper,
        SwiperSlide,
        ProgressCircle
    },
    props: {
        isShowAddHistoryBtn: {
            type: Boolean,
            default: false
        },
        stories: {
            type: Array,
        },
        isShowProgress: {
            type: Boolean,
            default: true
        },
    },
    data() {
        return {
            readMore: false,
            showModal: false,
            normalizeRadius: null,
            circumference: null,
            slideIndex: 0,
            storyThumbs: {
                spaceBetween: 16,
                slidesPerView: 'auto',
                speed: 700,
                freeMode: false
            },
            storyGallery: {
                spaceBetween: 0,
                slidesPerView: 'auto',
                speed: 700,
                preloadImages: false,
                lazy: {
                    loadPrevNext: true,
                    loadPrevNextAmount: 3,
                    checkInView: true
                },
                watchSlidesVisibility: true,
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        lazy: {
                            loadPrevNextAmount: 1,
                        },
                    },

                    992: {
                        lazy: {
                            loadPrevNextAmount: 3,
                        },
                    }
                }
            }
        }
    },
    watch: {},
    computed: {
        thumbsSwiper() {
            if (!this.stories && !this.showModal) return
            return this.$refs.thumbsRef.$swiper
        },

        gallerySwiper() {
            if (!this.stories && !this.showModal) return
            return this.$refs.galleryRef.$swiper
        },
    },

    mounted() {
        this.$nextTick(() => {
            const thumbs = this.$refs.thumbsRef.$swiper
            const gallery = this.$refs.galleryRef.$swiper
            gallery.controller.control = thumbs
        })

    },

    methods: {
        useConvertFilter(path, replacer) {
            return this.$options.filters.convertImage(path, replacer)
        },
        closeModal() {
            this.showModal = false
            this.readMore = false
            $('html').removeClass('modal-open')
        },
        slideChange() {
            this.readMore = false
            this.slideIndex = this.gallerySwiper.activeIndex
        },
        nextSlide() {
            this.readMore = false
            this.gallerySwiper.slideNext()
        },
        prevSlide() {
            this.readMore = false
            this.gallerySwiper.slidePrev()
        },
        prepareDescription(descr) {
            let descript = descr.replace(/(<([\/p>])+)>|(<([\/blockquote>][^\/u])+)>/gi, ''),
                htmlArray = descript.replace(/(\.+|\!|\?)(\"*|\'*|\)*|}*|]*)(\s|\n|\r|\r\n)/gm, "$1$2|").split("|"),
                stringsArray = descript.replace(/(<([^>]+)>)/gi, "").slice(0, 82).replace(/(\.+|\!|\?)(\"*|\'*|\)*|}*|]*)(\s|\n|\r|\r\n)/gm, "$1$2|").split("|"),
                htmlString = '',
                string = '',
                tagsDictionary = ['span', 'em', 'strong', 'u', 'i', 'b'];

            const parser = new DOMParser();

            htmlArray = htmlArray.slice(0, stringsArray.length)

            htmlSubstring(stringsArray.length - 1)

            function htmlSubstring(idx) {
                let arr = stringsArray[idx].trim().split(' '),
                    string = arr[arr.length - 1]

                htmlArray[idx] = htmlArray[idx].slice(0, (htmlArray[idx].indexOf(string) + string.length))
                htmlString = htmlArray.join(' ')
                parseHtmlString(htmlString)
            }

            function parseHtmlString(string) {
                let doc = parser.parseFromString(string, "text/html"),
                    tags = doc.body.getElementsByTagName('*'),
                    tagPosition = 0,
                    tmpl = ''

                for (let i = 0; i < tags.length; i++) {
                    let tagName = tags[i].tagName.toLowerCase();

                    if (tagsDictionary.includes(tagName)) {

                        if (string.indexOf(`</${tagName}>`, tagPosition) > 0) {
                            tagPosition = string.indexOf(`</${tagName}>`, tagPosition)
                        } else {
                            tmpl += `</${tagName}>`
                        }
                    }
                }

                htmlString += tmpl
            }

            return {
                htmlString: htmlString += htmlString.length === 82 ? '...' : '',
                string
            }
        },
        slideClicked(idx) {
            $('html').addClass('modal-open')

            this.readMore = false
            this.slideIndex = idx
            this.gallerySwiper.lazy.load();
            this.gallerySwiper.slideTo(idx)
            this.showModal = true
        }
    }

}
</script>

<style lang="scss">
.stories__gallery-body {
    position: absolute;
    bottom: 30px;
    left: 20px;
    right: 20px;
    width: calc(100% - 40px);
    z-index: 2;

    *:not(a) {
        color: #fff !important;
    }

    a {
        color: #2E76E4 !important;
        transition: .2s ease;

        &:hover {
            opacity: .8;
        }
    }

    .read-more-button {
        width: 100%;
        border: 1px solid white;
        border-radius: 25px;
        padding: 5px 0;
        font-size: 12px;
        margin-top: 10px;
    }
}

.stories__gallery-body-full {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 80%;
    width: 100%;
    background: #fff;
    border-radius: 20px 20px 0 0;
    color: #333333;
    transition: height 400ms;
    overflow: hidden;
    z-index: 10;

    &-bg {
        z-index: 5;
        height: 100%;
        width: 100%;
        cursor: pointer;
        top: 0;
        left: 0;
        position: absolute;
        background: #0000002e;
    }

    &-title {
        padding: 15px 35px;
        font-size: 14px;
        line-height: 16px;
        border-bottom: 1px solid #F1F2F4;
        height: 10%;
        font-weight: bold;


        div {
            position: absolute;
            right: 20px;
            top: 15px;
            cursor: pointer;
        }
    }

    &-content {
        height: 75%;
        padding: 24px;
        overflow: auto;
    }

    &-footer {
        height: 15%;
        width: 100%;
        border-top: 1px solid #F1F2F4;
        position: absolute;
        bottom: 0;
    }
}
</style>

<style lang="scss" scoped>

.stories__thumbs-story {
    width: 100%;
    height: 68px;
    background: #2e76e4;
    color: #fff;
    font-size: 40px;
    line-height: 1;
    text-align: center;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    overflow: hidden;
    cursor: pointer;
    transition: opacity .2s ease;

    &:hover {
        opacity: .8;
    }
}

.modal-enter-active, .modal-leave-active {
    transition: opacity .2s ease .2s;
}

.modal-enter, .modal-leave-to /* .fade-leave-active до версии 2.1.8 */
{
    opacity: 0;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .2s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
{
    opacity: 0;
}

</style>
